"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FixCosts["default"];
  }
});
var _FixCosts = _interopRequireDefault(require("./FixCosts"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }